import { combineReducers } from 'redux';
import loginReducer from './loginReducer';
import registerReducer from './registerReducer';
import organizationReducer from "./organizationReducer";
import domainReducer from "./domainReducer";
import settingsReducer from "./settingsReducer";
import scanQueueReducer from "./scanqueueReducer";
import usersReducers from "./usersReducers";
import customerReducer from "./customerReducer";
import monitorReducer from "./monitorReducer";
import scanInfoReducer from "./scanInfoReducer";
import reportsReducer from "./reportsReducer";
import dashboardReducer from "./dashboardReducer";
import thirdPartyRiskReducer from "./thirdPartyRiskReducer";


const rootReducer = combineReducers({
    login: loginReducer,
    organization: organizationReducer,
    register: registerReducer,
    domain: domainReducer,
    settings: settingsReducer,
    scanQueue: scanQueueReducer,
    users: usersReducers,
    customer: customerReducer,
    monitor: monitorReducer,
    scanInfo: scanInfoReducer,
    reports: reportsReducer,
    dashboard: dashboardReducer,
    thirdPartyRisk: thirdPartyRiskReducer
});
  
export default rootReducer;